import React from "react";
import Nav from "@/components/windie/Nav";
import Hero from "@/components/windie/Hero";
import ProductPreview from "@/components/windie/ProductPreview";
import NotAnotherChat from "@/components/windie/NotAnotherChat";
import Extensions from "@/components/windie/Extensions";
import ClosingCTA from "@/components/windie/ClosingCTA";
import LegalFooter from "@/components/windie/LegalFooter";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-paper text-ink">
      <Nav />
      <Hero />
      <ProductPreview />
      <NotAnotherChat />
      <Extensions />
      <ClosingCTA />
      <LegalFooter />
    </main>
  );
}
